module.exports = __webpack_public_path__ + "images/e8d8a2869add1024e201c8b56d7c31b9.png";